export enum QueryNameGraphQLEnum {
	LocationsQuery = 'locationsQuery',
	ZonesQuery = 'zonesQuery',
	LinesQuery = 'linesQuery',
	NotificationTopicsQuery = 'notificationTopicsQuery',
	NotificationRecipientsQuery = 'notificationRecipientsQuery',
	DevicesQuery = 'devicesQuery',
	SimCardsQuery = 'simCardsQuery',
	SensorsQuery = 'sensorsQuery',
	ProductsQuery = 'productsQuery',
	SensorsGroupsQuery = 'sensorsGroupsQuery',
	ShiftsQuery = 'shiftsQuery',
	ShiftLocationsQuery = 'shiftLocationsQuery',
	MachineStatusesQuery = 'machineStatusesQuery',
	SingleOperationStatusesQuery = 'singleOperationStatusesQuery',
	ComponentsQuery = 'componentsQuery',
	ComponentFeedersQuery = 'componentFeedersQuery',
	ComponentToolsQuery = 'componentToolsQuery',
	FeedersQuery = 'feedersQuery',
	ToolsQuery = 'toolsQuery',
	TagsQuery = 'tagsQuery',
	FingersQuery = 'fingersQuery',
	ItemClassesQuery = 'itemClassesQuery',
}
